import { D as DialogExt } from './dialog-nybQUbi-.js';
import './bodyScrollLock-BdpZ2Ojz.js';
import './pubsub-COBwjfLh.js';
import './notyf-DIw0RvBj.js';

class DrawerElement extends DialogExt {
  /** @type {(() => void) | null} */ #onResize = null;

  open() {
    super.open();
    this.#bindResizeClose();
  }

  close() {
    this.#unbindResizeClose();
    super.close();
  }

  /**
   * Close when layout width changes (orientation / crossing breakpoints).
   * Ignore height-only resizes: iOS Safari fires those when the bottom chrome
   * shows over a sticky footer control (e.g. add to cart).
   */
  #bindResizeClose() {
    this.#unbindResizeClose();
    const width = window.innerWidth;
    this.#onResize = () => {
      if (window.innerWidth === width) return;
      this.close();
    };
    window.addEventListener('resize', this.#onResize);
  }

  #unbindResizeClose() {
    if (!this.#onResize) return;
    window.removeEventListener('resize', this.#onResize);
    this.#onResize = null;
  }
}

customElements.define('drawer-element', DrawerElement);
